import { render, staticRenderFns } from "./AddFormNew.vue?vue&type=template&id=2e530ae4&scoped=true&"
import script from "./AddFormNew.vue?vue&type=script&lang=js&"
export * from "./AddFormNew.vue?vue&type=script&lang=js&"
import style0 from "./AddFormNew.vue?vue&type=style&index=0&id=2e530ae4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e530ae4",
  null
  
)

export default component.exports